import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Card, CardContent, TextField, Button, Typography, Alert } from '@mui/material';
import { authAPI } from '../services/api';

export default function AcceptInvite() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { setError('Passwords do not match'); return; }
    if (password.length < 8) { setError('Password must be at least 8 characters'); return; }
    setLoading(true);
    try {
      const res = await authAPI.acceptInvite(token, password);
      localStorage.setItem('okc_token', res.data.data.token);
      localStorage.setItem('okc_user', JSON.stringify(res.data.data.user));
      const u = res.data.data.user || {};
      navigate(u.role === 'admin' ? '/admin'
        : u.role === 'viewer' ? '/viewer'
        : u.role === 'facilitator' ? '/facilitator' : '/reviewer', { replace: true });
    } catch (err) {
      setError((err.response && err.response.data && err.response.data.error) || 'Failed to accept invitation');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
               background: 'linear-gradient(135deg, #1a5276 0%, #2980b9 100%)' }}>
      <Card sx={{ maxWidth: 420, width: '100%', mx: 2 }}>
        <CardContent sx={{ p: 4 }}>
          <Typography variant="h5" sx={{ mb: 0.5, color: 'primary.main' }}>Welcome, Reviewer</Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Set your password to activate your account
          </Typography>
          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          <form onSubmit={handleSubmit}>
            <TextField fullWidth label="New Password" type="password" value={password}
              onChange={(e) => setPassword(e.target.value)} sx={{ mb: 2 }} required />
            <TextField fullWidth label="Confirm Password" type="password" value={confirm}
              onChange={(e) => setConfirm(e.target.value)} sx={{ mb: 3 }} required />
            <Button fullWidth variant="contained" type="submit" size="large" disabled={loading}>
              {loading ? 'Setting up…' : 'Set password & continue'}
            </Button>
          </form>
        </CardContent>
      </Card>
    </Box>
  );
}
